import { commonUtils } from '@/helpers/commonUtils'
import styles from './PdfPage5.module.less'
import PdfPage from '../PdfPage/PdfPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPage5({ onRendered, no }: Props) {
  const { t } = useTranslation()
  useEffect(() => {
    onRendered(1)
  }, [])

  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-3/PDF-bg-3.jpg')} no={no}>
      <div className={styles.pdfPage5}>
        <img
          className={styles.cntTitle}
          src={commonUtils.getImagePath('PDFDownload/02.png')}
          alt=''
        />
        <img
          className={styles.circle}
          src={commonUtils.getImagePath('PDFDownload/pdf-page-3/page3-icon.png')}
        />
        <div className={styles.desc}>{t('dashboard.projectDetailPage.primaryAnalysis')}</div>
      </div>
    </PdfPage>
  )
}

export default PdfPage5
